import { render, staticRenderFns } from "./ManagePaymentMethods.vue?vue&type=template&id=0a19cfb1&"
import script from "./ManagePaymentMethods.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ManagePaymentMethods.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports